module.exports = __webpack_public_path__ + "img/Frame4.fa8e773a.png";